import React from 'react';
import { Row, Col } from 'reactstrap';
import styled from 'styled-components';
import SectionButtons from './SectionButtons';
export var PageHeadingContainer = styled.div.withConfig({
  displayName: "PageHeading__PageHeadingContainer",
  componentId: "flmloy-0"
})(["text-align:center;font-size:18px;padding:20px 0 ", " 0;"], function (_ref) {
  var sections = _ref.sections;
  return sections && sections.length ? '50px' : '20px';
});

var PageHeading = function PageHeading(_ref2) {
  var children = _ref2.children,
      title = _ref2.title,
      overview = _ref2.overview,
      sections = _ref2.sections;
  return /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(PageHeadingContainer, null, /*#__PURE__*/React.createElement("h1", null, title), children, /*#__PURE__*/React.createElement("p", null, overview), /*#__PURE__*/React.createElement(SectionButtons, {
    sections: sections
  }))));
};

export default PageHeading;